import { render, staticRenderFns } from "./loading_more.vue?vue&type=template&id=3b25345f&scoped=true&"
import script from "./loading_more.vue?vue&type=script&lang=js&"
export * from "./loading_more.vue?vue&type=script&lang=js&"
import style0 from "./loading_more.vue?vue&type=style&index=0&id=3b25345f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b25345f",
  null
  
)

export default component.exports